.referralContainer {
  backdrop-filter: blur(25px);
  background: var(--light-100);
  border-radius: 10px;
  box-shadow: 1px 1px 0px 0px #fff inset, 0px 8px 37px 0px rgba(0, 0, 0, 0.1);
  display: flex;
  padding: 10px 12px;
  align-items: flex-start;
  gap: 6px;

  .textAndIcon {
    display: flex;
    align-items: flex-end;

    .iconContainer {
      margin-right: 18px;
      margin-bottom: -2px;
    }
  }
}
